/**
 * Obrade (shema `jobs` na backendu). Nazivlje u sučelju: cron job = „vrsta obrade",
 * execution = „obrada", execution log = „log obrade".
 *
 * Obrade pokreće zasebni proces `AutoBiz.CronJobs`; administracija ih samo gleda i, kad
 * zapnu, vraća im status. Statusi su stringovi iz baze — prate `CronJobStatuses` i
 * `CronJobExecutionStatuses` u `AutoBiz.Core`.
 */

/** Status vrste obrade. Planer preskače `running` i `inactive`. */
export type CronJobStatus = "running" | "finished" | "error" | "inactive";

/**
 * Status jedne obrade. `aborted` upisuje samo administracija, kad resetira vrstu obrade koja je
 * zapela u `running` — sama obrada ga nikad ne postavlja.
 */
export type CronJobExecutionStatus = "running" | "finished" | "error" | "aborted";

export interface CronJobExecutionSummary {
  id: number;
  started: string;
  finished: string | null;
  status: CronJobExecutionStatus;
  /** Za obradu koja još traje — koliko već radi. */
  durationSeconds: number;
}

export interface CronJob {
  id: string;
  name: string;
  slug: string;
  description: string;
  status: CronJobStatus;
  lastRun: string | null;
  nextRun: string | null;
  /** Zastavica koju planer gleda pri sljedećem prolazu; obrada je sama gasi kad krene. */
  manualRun: boolean;
  metadata: string | null;
  /** Backend odlučuje — reset je dopušten samo iz `running` i `error`. */
  canResetStatus: boolean;
  executionCount: number;
  lastExecution: CronJobExecutionSummary | null;
}

export interface CronJobExecutionRow {
  id: number;
  cronJobId: string;
  started: string;
  finished: string | null;
  status: CronJobExecutionStatus;
  metadata: string | null;
  durationSeconds: number;
  logCount: number;
}

/** Obrada s podacima o vrsti obrade — zaglavlje ekrana s logom. */
export interface CronJobExecution extends CronJobExecutionRow {
  cronJobName: string | null;
  cronJobSlug: string | null;
}

export interface CronJobExecutionLogRow {
  id: number;
  cronJobExecutionId: number;
  log: string;
  created: string;
  /** Postavljeno kad obrada isti zapis dopuni (npr. brojač napretka). */
  updated: string | null;
}

export interface CronJobExecutionSearchFormValues {
  /** Prazno = svi statusi. */
  status: string;
}

export interface CronJobExecutionLogSearchFormValues {
  search: string;
}

export enum CronJobEventType {
  DETAIL = "detail",
  RESET_STATUS = "resetStatus",
}

export enum CronJobExecutionEventType {
  LOGS = "logs",
}
